export default class BlogFilter {

    constructor() {
        this.defaults = {
            postWrapper: '.js-post-wrapper',
            paginationWrapper: '.js-pagination-wrapper',
            paginationItem: '.js-pagination-item',
            activeCategory: '.active-checked',
            filterList: '.js-sidebar-filter',
            category: '.js-blog-category',
            paginationArrow: '.js-pagination-arrow',
            postItem: '.js-post-item',
            asset: '.by_asset-list',
            service: '.by_service-list',
            type: '.by_type-list',
            filterCheckbox: '.filter-checkbox',
            outOf: '.js-out-of',
            search: '.js-search',
            checkboxLabel: '.js-checkbox-label',
            paginationItemBtn: '.js-pagination-item-btn',

        };
        if (this.getBlogPostWrapper().length > 0) {
            this.init();
        }
    }

    getBlogPostWrapper() {
        return $(this.defaults.postWrapper);
    }

    getBlogPaginationWrapper() {
        return $(this.defaults.paginationWrapper);
    }

    getPaginationItem() {
        return this.getBlogPaginationWrapper().find(this.defaults.paginationItem);
    }

    getFilterList() {
        return $(this.defaults.filterList);
    }

    getCheckboxLabel() {
        return $(this.defaults.checkboxLabel);
    }

    getSearch() {
        return $(this.defaults.search);
    }

    getPaginationArrow() {
        return $(this.defaults.paginationArrow);
    }

    getOutOf() {
        return $(this.defaults.outOf);
    }

    init() {
        console.log('BlogFilter init()');

        let delay = (function () {
            let timer = 0;
            return function (callback, ms) {
                clearTimeout(timer);
                timer = setTimeout(callback, ms);
            };
        })();

        this.getSearch().on('keyup', (e) => {
            let self = $(e.currentTarget);
            var code = e.keyCode || e.which;
            if (code === 13) {
                return;
            }

            let page = 1;

            delay(() => {
                $.ajax({
                    url: apiUrl + '/search/',
                    type: 'GET',
                    dataType: 'json',
                    data: {
                        s: self.val()
                    },

                }).done((data) => {
                    this.getBlogPostWrapper().html(data.posts);

                    if (data.pagination !== -1) {
                        this.getBlogPaginationWrapper().html(data.pagination);
                    }

                    this.updateUrls(data.url);

                    if (this.getPaginationItem().length > 0) {
                        this.getPaginationItem().removeClass('is-active');
                        $(`#${page}`).addClass('is-active');
                    }

                    let postCount = parseInt(this.getOutOf().attr('data-posts'));
                    let pagePostCount = 0;
                    if (data.count > postCount) {
                        pagePostCount = data.count - postCount;
                    } else if (data.count < postCount) {
                        pagePostCount = data.found;
                    } else {
                        pagePostCount = page * postCount;
                    }

                    this.getOutOf().text('Insights ' + ((page * postCount) - postCount) + '-' + (pagePostCount + ' out of ' + data.found));
                    this.getCheckboxLabel().removeClass('is-opacity');
                    this.getCheckboxLabel().find(this.defaults.filterCheckbox).removeClass('active-checked');
                });
            }, 500);
        });

        this.getBlogPaginationWrapper().on('click', this.defaults.paginationItem, (ev) => {
            ev.preventDefault();

            if (this.isFilterInProgress() && $(this.defaults.paginationItem).hasClass('is-active')) {
                return;
            }

            this.disableFilter();

            const page = $(ev.currentTarget).attr('data-page');

            this.ajaxCall(page);
        });

        this.getBlogPaginationWrapper().on('click', this.defaults.paginationArrow, (ev) => {

            ev.preventDefault();

            if (this.isFilterInProgress()) {
                return;
            }

            this.disableFilter();

            const page = parseInt($(ev.currentTarget).attr('data-current'));

            const side = parseInt($(ev.currentTarget).data('side'));

            this.getPaginationArrow().attr('data-current', page + side);

            this.ajaxCall(page + side);
        });

        this.getFilterList().on('click', this.defaults.filterCheckbox, (ev) => {
            this.addCheckboxActive($(ev.currentTarget));
        });

        this.getFilterList().on('click', this.defaults.filterCheckbox, (ev) => {

            if (this.isFilterInProgress()) {
                return;
            }

            this.disableFilter();

            this.ajaxCall(1);
            this.ajaxFilters();
        });

        $(document).on('click', this.defaults.paginationItem, (ev) => {
            if ($(ev.currentTarget).hasClass('is-active')) {
                return;
            }

            setTimeout(() => {
                TweenMax.to($("html, body"), 1, {
                    scrollTop: $(this.defaults.postWrapper).offset().top - 200,
                    ease: Expo.easeInOut,
                });
            }, 300);
        });

        $(document).on('click', this.defaults.paginationItemBtn, (ev) => {

            setTimeout(() => {
                TweenMax.to($("html, body"), 1, {
                    scrollTop: $(this.defaults.postWrapper).offset().top - 200,
                    ease: Expo.easeInOut,
                });
            }, 300);
        });
    }

    addCheckboxActive(self) {
        if (self.hasClass('active-checked')) {
            self.removeClass('active-checked');
        } else {
            self.addClass('active-checked');
        }
    }

    ajaxFilters() {

        let asset = [];
        let service = [];
        let type = [];

        this.getFilterList().find(this.defaults.activeCategory).each(function () {
            if ($(this).hasClass('asset')) {
                if ($.inArray($(this).val(), asset) === -1) {
                    asset.push($(this).val());
                }
            } else if ($(this).hasClass('service')) {
                if ($.inArray($(this).val(), service) === -1) {
                    service.push($(this).val());
                }
            } else {
                if ($.inArray($(this).val(), type) === -1) {
                    type.push($(this).val());
                }
            }
        });
	
	    this.getSearch().val('');

        $.ajax({
            url: apiUrl + '/filters-update/',
            type: 'GET',
            dataType: 'json',
            data: {
                asset: asset,
                service: service,
                type: type,
            },
        }).done((data) => {
            this.getCheckboxLabel().addClass('is-opacity');
            data.categories.forEach(function (item, index) {
                $('#checkbox-' + item).removeClass('is-opacity');
            });
        });
	    
    }

    ajaxCall(page) {

        let asset = [];
        let service = [];
        let type = [];

        this.getFilterList().find(this.defaults.activeCategory).each(function () {
            if ($(this).hasClass('asset')) {
                if ($.inArray($(this).val(), asset) === -1) {
                    asset.push($(this).val());
                }
            } else if ($(this).hasClass('service')) {
                if ($.inArray($(this).val(), service) === -1) {
                    service.push($(this).val());
                }
            } else {
                if ($.inArray($(this).val(), type) === -1) {
                    type.push($(this).val());
                }
            }
        });
        
        let search = this.getSearch().val();
        

        $.ajax({
            url: apiUrl + '/filter-blog/',
            type: 'GET',
            dataType: 'json',
            data: {
                page: page,
                asset: asset,
                service: service,
                type: type,
	            search: search
            },
        }).done((data) => {
            this.getBlogPostWrapper().html(data.posts);

            
            if (data.pagination !== -1) {
                this.getBlogPaginationWrapper().html(data.pagination);
            }

            this.updateUrls(data.url);

            if (this.getPaginationItem().length > 0) {
                this.getPaginationItem().removeClass('is-active');
                $(`#${page}`).addClass('is-active');
            }

            let postCount = parseInt(this.getOutOf().attr('data-posts'));
            let pagePostCount = 0;
            if (data.count > postCount) {
                pagePostCount = data.count - postCount;
            } else if (data.count < postCount) {
                pagePostCount = data.found;
            } else {
                pagePostCount = page * postCount;
            }

            this.getOutOf().text('Insights ' + ((page * postCount) - postCount) + ' - ' + (pagePostCount + ' out of ' + data.found));

            this.enableFilter();

        });
    }

    disableFilter() {
        $('body').addClass('is-filter-disabled');
    }

    enableFilter() {
        $('body').removeClass('is-filter-disabled');
    }

    isFilterInProgress() {

        return $('body').hasClass('is-filter-disabled');
    }

    updateUrls(url) {

        history.pushState(null, null, url);

    }
}
